import DataSummaryCard from "./DataSummaryCard";

export default DataSummaryCard;
